import type { FC } from 'react';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

export const CHATBOT_ERROR_DISPLAY = 'chatbot-error-display';

interface ErrorDisplayProps {
  errorMessage: string;
  onClick: () => void;
}

export const ErrorDisplay: FC<ErrorDisplayProps> = ({
  errorMessage,
  onClick,
}) => (
  <Stack
    direction="column"
    sx={styles.wrapper}
    data-test-id={CHATBOT_ERROR_DISPLAY}
  >
    <Stack
      direction="row"
      spacing={1.25}
      sx={styles.errorBox}
      onClick={onClick}
    >
      <RefreshRoundedIcon />
      <Typography variant="body4" sx={{ lineHeight: '24px' }}>
        {errorMessage.replace('Error: ', '')} try again
      </Typography>
    </Stack>
  </Stack>
);

export default ErrorDisplay;
